import formatPlace from '@/utils/place/formatPlace';
import { concat, propEq, reject } from 'ramda';
import { formatNotificationConfig } from '@/utils/place/functions';
import updateObjectInArray from '@/utils/arrays/updateObjectInArray';

export default {
	setRegionFilter(state, value) {
		state.regionSelecionada = value;
	},
	setMessage(state, value) {
		state.message = value;
	},
	setPlaces(state, value) {
		state.places = value.map(formatPlace);
	},

	setPlacesUser(state, value) {
		state.placesUser = value.map(formatPlace);
	},
	addPlace(state, value) {
		state.places = state.places.concat(formatPlace(value));
	},
	removePlace(state, id) {
		state.places = state.places.filter(item => item._id !== id);
	},
	setLoading: (state, loading) => (state.loading = loading),
	addNotificationConfig(state, notificationConfig) {
		state.notificationConfigurations = concat(state.notificationConfigurations, [
			formatNotificationConfig(notificationConfig),
		]);
	},
	deleteNotificationConfig(state, notificationConfigId) {
		//reject es muy similar a como funciona filter
		//reject devolverá el mismo mismo arreglo pero no incluyendo objetos con la propiedad _id = notificationConfigId
		state.notificationConfigurations = reject(propEq('_id', notificationConfigId))(
			state.notificationConfigurations
		);
	},
	updateNotificationConfigs(state, notificationConfig) {
		state.notificationConfigurations = updateObjectInArray(
			state.notificationConfigurations,
			formatNotificationConfig(notificationConfig)
		);
	},
	setSelectedNotificationConfig(state, notificationConfig) {
		state.selectedNotificationConfig = formatNotificationConfig(notificationConfig);
	},
	setHasNewPlace(state) {
		state.hasNewPlace = true;
		setTimeout(() => {
			state.hasNewPlace = false;
		}, 100);
	},
};
